import clsx from "clsx";

import { KEYS } from "@excalidraw/common";

import { ToolButton } from "./ToolButton";
import { handIcon } from "./icons";
import { t } from "../i18n";

import "./ToolIcon.scss";

type LockIconProps = {
  title?: string;
  name?: string;
  checked: boolean;
  onChange?(): void;
  isMobile?: boolean;
  visible?: boolean;
  showKeyShortcut?: boolean;
};

export const HandButton = (props: LockIconProps) => {
  if (props.visible === false) {
    return null;
  }

  const showKeyShortcut = props.showKeyShortcut !== false;
  const handTitle = props.title ?? t("toolBar.hand");
  const title = showKeyShortcut ? `${handTitle} — H` : handTitle;

  return (
    <ToolButton
      className={clsx("Shape", { fillable: false })}
      type="radio"
      icon={handIcon}
      name="editor-current-shape"
      checked={props.checked}
      title={title}
      keyBindingLabel={
        showKeyShortcut && !props.isMobile
          ? KEYS.H.toLocaleUpperCase()
          : undefined
      }
      aria-label={title}
      aria-keyshortcuts={showKeyShortcut ? KEYS.H : undefined}
      data-testid={`toolbar-hand`}
      onChange={() => props.onChange?.()}
    />
  );
};
